import * as rax from 'retry-axios';
import axios from 'axios';

/**
 *
 * @param data
 * @returns {IterableIterator<Promise<AxiosResponse<T>>>}
 * {"price":655,"priceBus":425,"priceZKm":110,"days":5,"freeKm":500,"versicherung":75}
 */
export async function requestPrice(data) {
  rax.attach();
  const params = {
    token: 'assadlklnn34nsdf!sdfsd',
    buchung: {
      start: data.startDate.format('YYYY-MM-DD'),
      start_zeit: data.startTime,
      ende: data.endDate.format('YYYY-MM-DD'),
      ende_zeit: data.endTime,
      bus: data.bus,
      km: data.km,
      navi: data.navi ? 1 : undefined,
      schneeketten: data.schneeketten ? 1 : undefined,
      wechselrichter: data.wechselrichter ? 1 : undefined,
      versicherung: data.versicherung ? 1 : undefined,
      kindersitz: data.kindersitz ? 1 : undefined,
      laderampe: data.laderampe ? 1 : undefined,
      Rollstuhlhaltesystem: data.Rollstuhlhaltesystem ? 1 : undefined,
    },
  };

  return axios.post('https://api.gruppenbus.com/preisForBuchung', params, {
    timeout: 5000,
  });
}

export async function createBooking(booking) {
  rax.attach();
  // Do not leak moment objects / internal UI state to the API
  const {
    startDate,
    endDate,
    startTime,
    endTime,
    navi,
    schneeketten,
    wechselrichter,
    versicherung,
    kindersitz,
    laderampe,
    Rollstuhlhaltesystem,
    website,
    form_started_at,
    ...rest
  } = booking;

  const params = {
    token: 'assadlklnn34nsdf!sdfsd',
    buchung: {
      ...rest,
      start: startDate.format('YYYY-MM-DD'),
      start_zeit: startTime,
      ende: endDate.format('YYYY-MM-DD'),
      ende_zeit: endTime,
      navi: navi ? 1 : undefined,
      schneeketten: schneeketten ? 1 : undefined,
      wechselrichter: wechselrichter ? 1 : undefined,
      versicherung: versicherung ? 1 : undefined,
      kindersitz: kindersitz ? 1 : undefined,
      laderampe: laderampe ? 1 : undefined,
      Rollstuhlhaltesystem: Rollstuhlhaltesystem ? 1 : undefined,
      // Anti-spam fields (server validates)
      website: website || '',
      form_started_at: form_started_at || Math.floor(Date.now() / 1000) - 30,
    },
  };

  return axios.post('https://api.gruppenbus.com/booking', params, {
    timeout: 5000,
  });
}

export async function createAnzeigeClick(anzeige) {
  rax.attach();
  const params = {
    token: 'assadlklnn34nsdf!sdfsd',
    anzeige,
  };

  return axios.post('https://api.gruppenbus.com/anzeigeClick', params, {
    timeout: 5000,
  });
}

const KM_PRICE_API_KEY = 'kaisjjtidk6983nndld93!wds';

export async function fetchKmPriceApi(endDateUnix) {
  rax.attach();
  return axios.post(
    'https://www.touralarm.de/Api2/preisForId',
    {
      id: 20, //Überkilometer
      website: 'Gruppenbus',
      gueltig_ab: endDateUnix,
    },
    {
      timeout: 5000,
      headers: {
        Authorization: `Basic ${btoa(`token:${KM_PRICE_API_KEY}`)}`,
      },
    }
  );
}
